import { MyLeadsAttributes, MyLeadsFilterTypes } from '../interfaces/myLeads';
import AdAudienceModel from './AdAudienceModel';
import { IntegrationTypes } from './ConnectionModel';

export type VariableType = 'SystemVariable' | 'Variable';

// TODO MM4580 - consider removal
export const FILTER_TYPES = {
  variableValues: 'variable_values',
  reachable: 'reachable',
  tags: 'tags',
  tagsFilters: 'tags_filters',
  convertedForm: 'converted_form',
  seenForm: 'seen_form',
  platforms: 'platforms',
  euLimits: 'eu_limits',
  promoterId: 'promoted_promoter_id',
} as const;

type UIFilterTypeTuple = typeof FILTER_TYPES;
export type UIFilterType = UIFilterTypeTuple[keyof UIFilterTypeTuple];

export type FilterType = string | UIFilterType;

export type SystemFilterItem = {
  value: string[];
  filterType: FilterType;
};

export type TagFilterValue = {
  name: string;
  kind: 'otn' | 'regular' | 'service';
};

export type TagFilterItem = {
  values: TagFilterValue[];
  operator: 'include' | 'exclude';
  filterType: typeof FILTER_TYPES.tagsFilters;
};

export type TagsFilters = {
  [key: string]: TagFilterItem;
};

export type FilterItemOperator =
  | 'equal'
  | 'not_equal'
  | 'starts_with'
  | 'ends_with'
  | 'contains'
  | 'does_not_contain'
  | 'greater_than'
  | 'less_than'
  | 'exists';

export const FilterItemOperatorTypes = {
  EQUAL: 'equal',
  NOT_EQUAL: 'not_equal',
  STARTS_WITH: 'starts_with',
  ENDS_WITH: 'ends_with',
  CONTAINS: 'contains',
  DOESN_NOT_CONTAIN: 'does_not_contain',
  GREATER_THAN: 'greater_than',
  LESS_THAN: 'less_than',
  EXISTS: 'exists',
};

export type FilterItem = {
  value: string | string[];
  operator?: FilterItemOperator | undefined;
  variableId: number;
  variableType: VariableType;
  variable: string;
  operatorI18N?: string; //// TODO change to enum or string literals
  filterType: FilterType;
  valid?: boolean;
  esType?: MyLeadsFilterTypes | null;
  excluded?: boolean;
};

// filter params is ordered numbered collection
export type FilterParamsNoLogic = {
  [K: string]: FilterItem | SystemFilterItem;
};

export type FilterParams =
  | (FilterParamsNoLogic & { logic: string })
  | Record<string, any>;

type SystemFilters = {
  [K: string]: SystemFilterItem;
};
export default interface AudiencesModel {
  id: number;
  name: string;
  userFullName: string;
  contactsCount: number;
  reachableContactsCount: number;
  reachableSmsContactsCount: number;
  reachableFacebookContactsCount: number | null;
  activePercentage: number;
  smsContactsCount: number;
  otnReachableContactsCounts: { tag: string; count: number }[];
  subscribedSmsContactsCount: number;
  sponsoredReachableContactsCount: number;
  sponsoredSubscribedContactsCount: number;
  createdAt: string;
  updatedAt: string;
  filterParams?: FilterParams;
  esFilters?: MyLeadsAttributes;
  tagsFilters?: TagsFilters;
  systemFilters?: SystemFilters;
  adAudience?: AdAudienceModel;
  predefinedFilters?: any; // TODO: Change as soon as BE settles down on the API format
  messengerAdAudience?: boolean;
  subscribedContactsCount: boolean;
  systemAudience?: boolean;
  recalculatedAt?: string;
  deleteContacts?: boolean;
  usedInActiveDrip?: boolean;
  campaignName: string;
  additional?: { kind: string } | null;
  hidden?: boolean | null;
  type?: 'common' | 'leads_db' | 'es_based';
  status: 'ready' | 'not_ready' | 'failed';
  automations?: [number, string];
  integrationTypes?: IntegrationTypes[];
}
